import React from "react";
import styles from "./Footer.module.css";

const Footer = () => {
    return (
        <>
            <div className={styles.footerPlaceholder}></div>
            <footer className={styles.footer}>
                <span>&copy;&nbsp;{new Date().getFullYear()}&nbsp;DDM Consulting</span>
            </footer>   
        </>
    )
}

export default Footer;